<template>
    <div >
        <div class="t_search_box" style="margin-left: 20px;">
            <div class="t_search_select" >
                <img src="../../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchinput" size="small" v-model="searchdata.phone" placeholder="请输入手机号"  clearable />
            </div> 
            <div class="t_search_select" >
                <el-select @change="changezt" v-model="searchdata.status" clearable placeholder="任务状态" size="small"  >
                    <el-option
                    v-for="item in zt.data"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                    />
                </el-select>
            </div> 
            <el-button @click="resetsearch" color="#F1F3F9" type="primary" style="margin-bottom: 10px;">重置</el-button>
        </div>
        <!-- 标题 -->
        <div class="t_title_box_f" style="justify-content:space-between;margin: 20px;">
            <div style="display: flex;align-items: center;">
                <div class="t_blue_line"></div>
                <div>添加列表</div>
            </div>
            <el-button  @click="exportlist" color="#4F46E5" type="primary">导出</el-button>
        </div>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data"  style="width: 100%" >
            
            <el-table-column prop="index" align="center" label="序号"  >
                <template #default="scope">
                    {{ scope.$index+1 }}
                </template>
            </el-table-column>
            <el-table-column prop="phone" align="center" label="手机号"  />
            <el-table-column prop="wechatName" align="center" label="好友信息"  />
            <el-table-column prop="updateTime" align="center" label="导入时间"  />
            <el-table-column prop="status" align="center" label="状态"  >
                <template #default="scope">
                    <span v-if="scope.row.status==0">
                        有效
                    </span>
                    <span v-if="scope.row.status==1">
                        无效
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="remark" align="center" label="备注"  />
        </el-table>
    </div>
</template>
<script setup>

import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Tickets,Picture } from '@element-plus/icons-vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { drlist } from '@/assets/js/common.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    getlist()
})
// 搜索
const searchdata = reactive({
    phone:'',
    status:'',
    id:route.query.id
})
//监听输入框
const searchinput = (e)=>{
    console.log(e)
    searchdata.phone = e
    getlist()
}

//状态列表
const zt = reactive({
    data:[
        {
            id:0,
            label:'有效'
        },
         {
            id:1,
            label:'无效'
        },
        
    ]
})
//监听下拉
const changezt = (e)=>{
    console.log(e)
    searchdata.status = e
    getlist()
}
//重置
const resetsearch = ()=>{
    searchdata.phone = ''
    searchdata.status = ''
    getlist()
}
//导出列表
const exportlist = ()=>{
    var exportL = JSON.parse(JSON.stringify(searchdata));
    exportL.corpId  = $cookies.get("fanscorpId")
    
    var str = '?'
    for (let key in exportL) {
        str=str+key+'='+exportL[key]+'&'
    }
    console.log( str.slice(0, -1)+'&addType='+route.query.addType)
    const a = document.createElement('a');
    a.setAttribute('download', '');
    a.setAttribute('href', _url2 + `/work/bcAddFriendTask/exportXlsImport`+ str.slice(0, -1)+'&addType='+route.query.addType);
    a.click();
}
//列表内容
const tableData = reactive({
    data:[]
})
//获取列表数据
const getlist = ()=>{
    drlist(_url2,searchdata).then((response)=>{
        console.log('导入数据列表')
        console.log(response)
        tableData.data = response.data.result
    })
}
</script>
<style scoped>
:deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_input_bg .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_textarea_nobod .el-textarea__inner)  {
    
    box-shadow: 0 0 0 0 ;
    resize: none;
    border-bottom: 1px solid #dcdfe6;
}
</style>